import {createStyles, makeStyles, Theme} from '@material-ui/core';
import {WHITE} from '../../../const/colors';
import {desktop, mobile} from '../../../const/sizes';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        priceSection: {
            backgroundColor: WHITE,
            padding: mobile.contentLargerSpacing,
            marginBottom: mobile.contentSmallerSpacing,
        },
        priceText: {
            flex: 1,
            fontSize: 18,
            fontWeight: 'bold',
        },
        price: {
            fontSize: 18,
            fontWeight: 'bold',
            color: theme.palette.secondary.main,
        },
        [theme.breakpoints.up('sm')]: {
            priceSection: {
                padding: `${desktop.contentSmallerSpacing} ${desktop.contentLargerSpacing}`,
            },
            priceText: {
                flex: 'none',
            },
            price: {
                marginLeft: mobile.contentSmallerSpacing,
            },
            priceContainer: {
                justifyContent: 'flex-start',
            },
        },
    }),
);

export default useStyles;
